import React from 'react';
import { configData } from "../config";
import './classes/QuickLinks.css';

// Who gets the live site's staff blocks in a page's right column (Quick Links and Applicant & Agent
// Search): administrators, SA admins, salespeople and sales directors
export const hasStaffBlocks = (roles) =>
    Array.isArray(roles) &&
    [configData.ROLE_ADMINISTRATOR, configData.ROLE_SAADMIN, configData.ROLE_SALES_PEOPLE, configData.ROLE_SALES_DIRECTOR]
        .some((role) => roles.includes(role));

// The live site's "Quick Links" block in the right column, for signed-in staff: under the form on
// the pages with the general quick form (degree pages, course pages outside /courses, conference
// pages), and at the top on the Courses and Conferences pages, the other course pages and the
// salary pages.
// Only the links live's block (smww_operations()) lists on these pages: administrators get
// Dashboard Home, Manage My Profile, My Account and People, and salespeople and sales directors
// Dashboard Home. Live lists SA admins' links only on their own dashboard pages, so an SA admin
// gets no block here. The links go to this site's pages, as the staff sidebar's do.
const QuickLinks = ({ roles }) => {
    if (!hasStaffBlocks(roles)) return null;
    const isAdministrator = roles.includes(configData.ROLE_ADMINISTRATOR);
    const isSales = roles.includes(configData.ROLE_SALES_PEOPLE) || roles.includes(configData.ROLE_SALES_DIRECTOR);
    if (!isAdministrator && !isSales) return null;
    // The user's dashboard is /user/<Drupal uid>, where signing in and the header's name link go
    const dashboardHome = <li><a href={"/user/" + localStorage.getItem('drupal_uid')}>Dashboard Home</a></li>;
    return (
        // Headed like the Success Stories block under it
        <div className="course-success-box quick-links-block">
            <h2 className="success-title">Quick Links</h2>
            <ul className="quick-links-list">
                {/* Live gives administrators their own list only */}
                {isAdministrator ? (
                    <>
                        {dashboardHome}
                        <li><a href={"/user/" + localStorage.getItem('drupal_uid') + "/edit"}>Manage My Profile</a></li>
                        <li><a href="/my_scouts_account">My Account</a></li>
                        <li><a href="/manage/people">People</a></li>
                    </>
                ) : dashboardHome}
            </ul>
        </div>
    );
};

export default QuickLinks;
